import { useTranslation } from "react-i18next";
import Reveal from "@/components/base/Reveal";

const pillars = [
  {
    key: 1,
    image:
      "https://storage.readdy-site.link/project_files/123cd24f-3c94-48d0-9c42-347ad31c80a7/06de0151-e9da-47ee-89cb-2cba20dbbed2_compressed_-2026-07-24-20.41.39.webp",
    objectPosition: "object-center",
    inset: "inset-0",
  },
  {
    key: 2,
    image:
      "https://storage.readdy-site.link/project_files/123cd24f-3c94-48d0-9c42-347ad31c80a7/3be5e952-2366-4482-8311-cf884f6b5c29_compressed_kailingpiano-changsha-concert-hall-1529893.webp",
    objectPosition: "object-center",
    inset: "inset-0",
  },
  {
    key: 3,
    image:
      "https://storage.readdy-site.link/project_files/123cd24f-3c94-48d0-9c42-347ad31c80a7/1fecc59f-503c-4b54-8b19-8b26d31edd82_compressed_-2026-07-26-0.46.47.webp",
    objectPosition: "object-center",
    inset: "inset-0",
  },
];

export default function ThreePillars() {
  const { t } = useTranslation();
  const titleLines = t("threepillars.title").split("\n");

  return (
    <section id="pillars" className="relative bg-midnight py-32 md:py-44 overflow-hidden">
      <div className="w-full px-6 md:px-12 lg:px-16">
        <Reveal>
          <div className="text-center mb-24 md:mb-32">
            <h2 className="text-marble font-serif font-light leading-snug tracking-wide">
              <span className="block text-xl md:text-4xl lg:text-5xl whitespace-nowrap">
                {titleLines[0]}
              </span>
              <span className="block text-lg md:text-xl lg:text-2xl text-marble/70 mt-2">
                {titleLines[1]}
              </span>
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
            {pillars.map((p) => (
              <div
                key={p.key}
                className="group relative overflow-hidden rounded-xl aspect-[3/4]"
              >
                <div
                  className={`absolute ${p.inset} overflow-hidden rounded-lg transition-transform duration-1000 group-hover:scale-105`}
                >
                  <img
                    src={p.image}
                    alt=""
                    className={`w-full h-full object-cover ${p.objectPosition} brightness-[0.9] contrast-[1.08] saturate-[0.82]`}
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-deepblack/90 via-deepblack/30 to-transparent" />
                <div className="absolute inset-0 flex flex-col justify-end p-6 md:p-8 transition-all duration-1000 md:opacity-0 md:translate-y-4 md:group-hover:opacity-100 md:group-hover:translate-y-0">
                  <p className="text-champagne text-xs font-sans tracking-widest uppercase mb-2">
                    {t(`threepillars.pillar${p.key}.subtitle`)}
                  </p>
                  <h3 className="text-marble font-serif text-xl md:text-2xl font-light tracking-wide mb-2 whitespace-nowrap">
                    {t(`threepillars.pillar${p.key}.title`)}
                  </h3>
                  <p className="text-marble/60 text-sm font-sans leading-relaxed whitespace-pre-line">
                    {t(`threepillars.pillar${p.key}.desc`)}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}